export default {"src":"/_next/static/media/img-order.9fab504a.svg","height":135,"width":135,"blurWidth":0,"blurHeight":0};